import { render, staticRenderFns } from "./BaseSidebar.vue?vue&type=template&id=ee32db6c"
import script from "./BaseSidebar.vue?vue&type=script&lang=js"
export * from "./BaseSidebar.vue?vue&type=script&lang=js"
import style0 from "./BaseSidebar.vue?vue&type=style&index=0&id=ee32db6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports